import React, { useEffect, useState } from "react";
import { Star, Quote, MessageSquarePlus } from "lucide-react";
import { AGENT } from "@/lib/site";
import { api } from "@/lib/api";
import ReviewSubmitDialog from "@/components/ReviewSubmitDialog";

export default function AboutAgent() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    api
      .get("/reviews")
      .then((res) => mounted && setReviews(res.data || []))
      .catch(() => {})
      .finally(() => mounted && setLoading(false));
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <section
      id="o-meni"
      data-testid="about-section"
      className="py-24 md:py-32"
      style={{ background: "var(--vp-sand)" }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-24">
            <img
              src="https://images.unsplash.com/photo-1628348068343-c6a848d2b6dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBmaW5hbmNpYWwlMjBjb25zdWx0YW50fGVufDB8fHx8MTc4MDc2MDA4OXww&ixlib=rb-4.1.0&q=85"
              alt={AGENT.name}
              className="rounded-3xl shadow-xl w-full h-[460px] object-cover"
            />
            <div className="mt-6">
              <div className="text-sm font-semibold tracking-widest uppercase text-[var(--vp-primary)] mb-2">
                Mnenja strank
              </div>
              <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight leading-tight">
                {AGENT.name}
              </h2>
              <div className="text-[var(--vp-muted)] mt-1 text-lg">{AGENT.title}</div>

              <div className="mt-6 flex flex-wrap gap-3">
                <a
                  href="#kontakt"
                  data-testid="about-cta"
                  className="rounded-full px-6 py-3 font-semibold text-white"
                  style={{ background: "var(--vp-primary)" }}
                >
                  Pišite mi
                </a>
                <ReviewSubmitDialog />
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 space-y-5" data-testid="reviews-list">
            {loading && (
              <div className="rounded-2xl border border-[var(--vp-border)] bg-white p-7 text-sm text-[var(--vp-muted)]">
                Nalaganje mnenj…
              </div>
            )}
            {!loading && reviews.length === 0 && (
              <div
                data-testid="reviews-empty"
                className="rounded-2xl border border-dashed border-[var(--vp-border)] bg-white p-10 text-center"
              >
                <MessageSquarePlus className="mx-auto text-[var(--vp-primary)]" size={36} />
                <h3 className="font-display text-xl font-bold mt-3">
                  Bodite prvi, ki delite mnenje
                </h3>
                <p className="text-sm text-[var(--vp-muted)] mt-2 max-w-md mx-auto">
                  Vaša iskrena izkušnja drugim pomaga, ko iščejo neodvisnega
                  zavarovalnega svetovalca.
                </p>
                <div className="mt-5 inline-flex">
                  <ReviewSubmitDialog triggerLabel="Napišite svoje mnenje" />
                </div>
              </div>
            )}
            {!loading &&
              reviews.map((t, i) => (
                <article
                  key={t.id || i}
                  data-testid={`testimonial-${i}`}
                  className="rounded-2xl bg-white border border-[var(--vp-border)] p-7 relative"
                >
                  <Quote
                    size={32}
                    className="absolute top-6 right-6 text-[var(--vp-accent)]/30"
                    aria-hidden
                  />
                  <div className="flex items-center gap-1 mb-3">
                    {[...Array(t.rating || 5)].map((_, j) => (
                      <Star key={j} size={14} fill="#D08C60" stroke="#D08C60" />
                    ))}
                  </div>
                  <p className="text-[var(--vp-text)] leading-relaxed">{t.quote}</p>
                  <div className="mt-4 flex items-center gap-3">
                    <div
                      className="h-10 w-10 rounded-full flex items-center justify-center font-display font-bold text-sm text-white"
                      style={{ background: "var(--vp-primary)" }}
                    >
                      {(t.name || "?")
                        .split(" ")
                        .map((p) => p[0])
                        .join("")
                        .slice(0, 2)
                        .toUpperCase()}
                    </div>
                    <div>
                      <div className="font-semibold text-sm">{t.name}</div>
                      {t.role && (
                        <div className="text-xs text-[var(--vp-muted)]">{t.role}</div>
                      )}
                    </div>
                  </div>
                </article>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
}
